// src/config/testCodingVersion.js

export const TestCodingVersion = {
  name: "Live TestCode Compiler",
  version: "v2.3.0",
  lastUpdated: "July 11, 2025",
//   builtWith: "React, Firebase Realtime DB, Judge0 API, Monaco Editor, Godbolt iframe",
  builtWith: "Love",
  github: "https://github.com/webdeveloperdesigner",
  features: [
    "Multiple-question coding quizzes",
    "Per-question marks and test case scoring",
    "Live Judge0-based code execution",
    "Custom input/output support",
    "Language selector (C, C++, Java, Python, JavaScript)",
    "Theme switcher (Dark, Light, High Contrast)",
    "Real-time timer display",
    "Result saving to Firebase",
    "Godbolt C++ integration",
    "Editor state persistence with localStorage",
  ],
  changelog: [
    {
      version: "v1.0.0",
      changes: [
        "Initial base version with single-question execution and submission.",
      ],
    },
    {
      version: "v1.1.0",
      changes: [
        "Added multiple test cases with result summary.",
      ],
    },
    {
      version: "v1.2.0",
      changes: [
        "Integrated Judge0 API with basic test validation.",
      ],
    },
    {
      version: "v2.0.0",
      changes: [
        "Major upgrade: Multiple questions in one quiz",
        "Score calculation per test case",
        "Firebase integration for result saving",
      ],
    },
    {
      version: "v2.1.0",
      changes: [
        "Custom test input/output feature",
        "Display error logs (stderr, compile_output)",
      ],
    },
    {
      version: "v2.2.0",
      changes: [
        "Theme switching support (light, dark, high contrast)",
        "Language selection dropdown (C, C++, Java, etc.)",
      ],
    },
    {
      version: "v2.3.0",
      changes: [
        "Godbolt iframe added for C++ code visualization",
        "Timer added to track quiz duration",
        "Monaco Editor state saved using localStorage",
      ],
    },
  ],
};


// export const TestCodingVersion = {
//   name: "Live TestCode Compiler",
//   version: "v1.0.2",
//   lastUpdated: "July 2025",
//   builtWith: "React + Firebase + Judge0 + Monaco Editor",
//   github: "https://github.com/vivek-motioncut",
// };
